export default __webpack_public_path__ + "67ee924e733b0c93f434dc72d3741439.png";